import { CompanyProfileClassifications } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

type CompanyProfileClassificationsNames = Capitalize<keyof CompanyProfileClassifications>;

function CompanyAccountClassifications() {}
enumify<CompanyProfileClassificationsNames, CompanyProfileClassificationsNames>(
    CompanyAccountClassifications,
    'CompanyAccountClassifications',
    {
        Corporate: 'Corporate',
        GlobalDistributionSystem: 'GlobalDistributionSystem',
        Inactive: 'Inactive',
        Internal: 'Internal',
        Marketing: 'Marketing',
        OnlineTravelAgency: 'OnlineTravelAgency',
        Private: 'Private',
        GovernmentEntity: 'GovernmentEntity',
    }
);

export default CompanyAccountClassifications as unknown as Enumify<
    CompanyProfileClassificationsNames,
    CompanyProfileClassificationsNames
>;
